import { Theme, css } from '@emotion/react';

export const paper = (theme: Theme, minWidthPx?: number, maxWidthPx?: number) => {
  return [
    minWidthPx &&
      css`
        & .MuiPopover-paper {
          min-width: ${minWidthPx}px;
        }
      `,
    maxWidthPx &&
      css`
        & .MuiPopover-paper {
          max-width: ${maxWidthPx}px;
        }
      `,
    css`
      & .MuiPopover-paper {
        border-radius: 0;
        box-shadow: ${theme.shadow[200]};
        margin-top: ${theme.spacing(1)}px;
      }
    `,
  ];
};
